import { writable } from "svelte/store";

const sanityProjectId = import.meta.env.VITE_SANITY_PROJECT_ID;
const sanityDataset = import.meta.env.VITE_SANITY_DATASET;
const sanityUseCdn = import.meta.env.VITE_SANITY_USE_CDN;

const sanityUrlPrefix = import.meta.env.VITE_SANITY_URL_PREFIX;
const sanityUrlQuery = import.meta.env.VITE_SANITY_URL_QUERY;

const MenuData = writable(
  {
    isLoaded: false,
    catalog: [],
    aboutUs: []
  }
);

async function fetchData() {
    try {
      const apiUrl = sanityUseCdn ? "apicdn" : "api";

      const sanityRequestUrl = `https://${sanityProjectId}.${apiUrl}.${sanityUrlPrefix}/${sanityDataset}?query=${sanityUrlQuery}`;
      const response = await fetch(sanityRequestUrl);
      
      let raw = await response.json();      
      const catalogData = raw.result[0];

      //const sortedArray = sortMenus(raw.result.menus, raw.result.menuOrder[0].groups);

      if(catalogData.catalog != null){
        MenuData.set(
          {
            isLoaded: true,
            catalog: catalogData.catalog,
            aboutUs: catalogData.aboutUs
          }
        );
        
      }

    } catch (error) {
      console.error('Error loading Menu JSON data:', error);
    }
}

export async function getCategoryByName(categoryName) {
  let category = null;

  let isMenuDataLoaded = false;
  MenuData.subscribe((data) => {
    isMenuDataLoaded = data.isLoaded;
  })();

  if (!isMenuDataLoaded) {
    await fetchData();
  }

  MenuData.subscribe((data) => {
    if (data.isLoaded) {
      category = data.catalog.find(category => category.name === categoryName);
    }
  })();

  return category;
}


export async function getItemByCategoryAndName(categoryName, itemName) {
  let category = null;
  let itemData = null;

  let isMenuDataLoaded = false;
  MenuData.subscribe((data) => {
    isMenuDataLoaded = data.isLoaded;
  })();

  if (!isMenuDataLoaded) {
    await fetchData();
  }

  MenuData.subscribe((data) => {
    if (data.isLoaded) {
      category = data.catalog.find(category => category.name === categoryName);
      if (category) {
        itemData = category.items.find(item => item.code === itemName);
      }
    }
  })();

  return itemData;
}


fetchData();

export default MenuData;